export default __webpack_public_path__ + "static/media/mPages.a7ae17cb.jfif";